import React from 'react';

const PremiumHeader = ({ title, lastWordAccent, subtitle }) => {
  return (
    <div className="mb-10 text-center">
      <h1 className="text-4xl font-black text-gray-900 mb-2 uppercase tracking-tighter">
        {title} <span className="text-orange-600">{lastWordAccent}</span>
      </h1>
      {subtitle && <p className="text-gray-500 font-medium italic">{subtitle}</p>}
    </div>
  );
};

export default PremiumHeader;
